/* eslint no-eval: 0 */
import React from "react";
import PropTypes from 'prop-types'
import TagManager from 'react-gtm-module'

class GoogleTagManager extends React.Component {
    componentDidMount() {
        const gtmConfigs = [
            {
                gtmId:          this.props.gtmId || '',
                dataLayerName:  this.props.dataLayerName || 'dataLayer',
                gtmVars:        this.props.gtmVars || {},
            },
            {
                gtmId:          this.props.gtmId2 || '',
                dataLayerName:  this.props.dataLayerName2 || 'dataLayer2',
                gtmVars:        this.props.gtmVars2 || {},
            }
        ];

        gtmConfigs.forEach(({gtmId, dataLayerName, gtmVars}) => {
            if (!gtmId) return;

            const tagManagerArgs = {
                gtmId,
                dataLayerName,
                auth: gtmVars.gtm_auth,
                preview: gtmVars.gtm_preview
            }

            // console.log('Setting gtm for following, ');
            // console.log(tagManagerArgs);

            TagManager.initialize(tagManagerArgs);
        })
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

GoogleTagManager.propTypes = {
    gtmId: PropTypes.string.isRequired,
    gtmId2: PropTypes.string,
    dataLayerName: PropTypes.string,
    dataLayerName2: PropTypes.string,
    scriptId: PropTypes.string,
    scriptId2: PropTypes.string,
    gtmVars: PropTypes.object,
    grmVars2: PropTypes.object,
};

export default GoogleTagManager;
